module.exports = __webpack_public_path__ + "static/media/bot.b9b9d486.svg";